import { Injectable } from '@angular/core';
import { FormExtractorService } from 'src/app/modules/shared/services/form-extractor.service';
import { TypeCPVClass } from '../../models/TypeCPVClass';
import { TypeFournitures } from '../../models/TypeFournitures';
import { TypeLieu } from '../../models/TypeLieu';
import { TypeObjCPV } from '../../models/TypeObjCPV';
import { TypeTravaux } from '../../models/TypeTravaux';
import { TypeVoie } from '../../models/TypeVoie';
import { AvisDataTransferService } from '../../../../../shared/services/avis-data-transfer.service';

@Injectable({
  providedIn: 'root'
})
export class DescriptionService {

  constructor(private avisDataTransferService: AvisDataTransferService) {
  }

  getDescription(controls: any, formExtractorService: FormExtractorService) {
    let objetComplementaire_iter = 0;
    let classSupplementaire_iterObjPrincipal = 0;

    const objetComplementaire_iters = formExtractorService.getIndexes(Array.from(controls.keys()), ['_SepSep_Initial_SepSep_Description'], 'SepSep_TypeObjCPV_index_');
    const classSupplementaire_itersObjPrincipal = formExtractorService.getIndexes(Array.from(controls.keys()), ['_SepSep_Initial_SepSep_Description_SepSep_TypeObjCPV_SepSep_TypeCPVClass_index_'], 'SepSep_TypeCPVClass_index_');


    const description = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.mapa.initialFromMAPA.description;
    description.cpv = new TypeObjCPV();
    for (const objetCompl of Array.from(objetComplementaire_iters)) {
      description.cpv.objetComplementaire[objetComplementaire_iter] = new TypeCPVClass();
      description.cpv.objetComplementaire[objetComplementaire_iter].classPrincipale = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_Description_SepSep_TypeObjCPV_index_' + (objetComplementaire_iter + 1) + '_SepSep_TypeCPVClass_SepAtt_classPrincipale'));
      let classSupplementaire_iter = 0;
      const classSupplementaire_iters = formExtractorService.getIndexes(Array.from(controls.keys()), ['_SepSep_Initial_SepSep_Description_SepSep_TypeObjCPV_index_' + (objetComplementaire_iter + 1)], 'SepSep_TypeCPVClass_index_');

      for (const classSup of Array.from(classSupplementaire_iters)) {
        description.cpv.objetComplementaire[objetComplementaire_iter].classSupplementaire[classSupplementaire_iter] = controls.get('_SepSep_Initial_SepSep_Description_SepSep_TypeObjCPV_index_' + (objetComplementaire_iter + 1) + '_SepSep_TypeCPVClass_index_' + (classSupplementaire_iter + 1) + '_SepAtt_classSupplementaire');
        classSupplementaire_iter++;
      }
      objetComplementaire_iter++;
    }
    description.cpv.objetPrincipal = new TypeCPVClass();
    description.cpv.objetPrincipal.classPrincipale = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_Description_SepSep_TypeObjCPV_SepSep_TypeCPVClass_SepAtt_classPrincipale'));
    for (const classSup of Array.from(classSupplementaire_itersObjPrincipal)) {
      description.cpv.objetPrincipal.classSupplementaire[classSupplementaire_iterObjPrincipal] = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_Description_SepSep_TypeObjCPV_SepSep_TypeCPVClass_index_' + (classSupplementaire_iterObjPrincipal + 1) + '_SepAtt_classSupplementaire'));
      classSupplementaire_iterObjPrincipal++;
    }
    const lieuExecutionLivraisonValue = controls.get('_SepSep_Initial_SepSep_Description_SepAtt_lieuExecutionCB');
    // Si le contrôle n'existe pas, on garde la valeur existante (ou true par défaut)
    const lieuExecutionLivraison = lieuExecutionLivraisonValue !== undefined
      ? !!lieuExecutionLivraisonValue
      : (description.isLieuExecutionLivraison !== undefined ? description.isLieuExecutionLivraison : true);

    if (lieuExecutionLivraison) {
      description.lieuLivraison = null;
      description.lieuExecution = null;
      description.lieuExecutionLivraison = new TypeLieu();
      description.lieuExecutionLivraison.cp = this.sanitizeString(controls.get('lieuExecutionLivraison_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepAtt_cp'));
      description.lieuExecutionLivraison.ville = this.sanitizeString(controls.get('lieuExecutionLivraison_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepAtt_ville'));
      description.lieuExecutionLivraison.voie = new TypeVoie();
      description.lieuExecutionLivraison.voie.nomvoie = this.sanitizeString(controls.get('lieuExecutionLivraison_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_nomvoie'));
      description.lieuExecutionLivraison.voie.num = this.sanitizeString(controls.get('lieuExecutionLivraison_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_num'));
      description.lieuExecutionLivraison.voie.typevoie = this.sanitizeString(controls.get('lieuExecutionLivraison_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_typevoie'));
    } else {
      description.lieuExecutionLivraison = null;
      description.lieuExecution = new TypeLieu();
      description.lieuExecution.cp = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepAtt_cp'));
      description.lieuExecution.ville = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepAtt_ville'));
      description.lieuExecution.voie = new TypeVoie();
      description.lieuExecution.voie.nomvoie = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_nomvoie'));
      description.lieuExecution.voie.num = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_num'));
      description.lieuExecution.voie.typevoie = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_typevoie'));
      description.lieuLivraison = new TypeLieu();
      description.lieuLivraison.cp = this.sanitizeString(controls.get('lieuLivraison_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepAtt_cp'));
      description.lieuLivraison.ville = this.sanitizeString(controls.get('lieuLivraison_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepAtt_ville'));
      description.lieuLivraison.voie = new TypeVoie();
      description.lieuLivraison.voie.nomvoie = this.sanitizeString(controls.get('lieuLivraison_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_nomvoie'));
      description.lieuLivraison.voie.num = this.sanitizeString(controls.get('lieuLivraison_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_num'));
      description.lieuLivraison.voie.typevoie = this.sanitizeString(controls.get('lieuLivraison_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_typevoie'));
    }
    description.isLieuExecutionLivraison = lieuExecutionLivraison;
    description.marcheFournitures = new TypeFournitures();
    description.marcheFournitures.achat =
      this.sanitizeString(controls.get('_SepSep_Initial_SepSep_Description_SepSep_TypeFournitures_SepAtt_achat'));
    description.marcheFournitures.creditBail =
      this.sanitizeString(controls.get('_SepSep_Initial_SepSep_Description_SepSep_TypeFournitures_SepAtt_creditBail'));
    description.marcheFournitures.location =
      this.sanitizeString(controls.get('_SepSep_Initial_SepSep_Description_SepSep_TypeFournitures_SepAtt_location'));
    description.marcheFournitures.locationVente =
      this.sanitizeString(controls.get('_SepSep_Initial_SepSep_Description_SepSep_TypeFournitures_SepAtt_locationVente'));
    description.marcheServices = controls.get('_SepSep_Initial_SepSep_Description_SepAtt_marcheServices');
    description.marcheTravaux = new TypeTravaux();
    description.marcheTravaux.conceptionRealisation =
      this.sanitizeString(controls.get('_SepSep_Initial_SepSep_Description_SepSep_TypeTravaux_SepAtt_conceptionRealisation'));
    description.marcheTravaux.execution =
      this.sanitizeString(controls.get('_SepSep_Initial_SepSep_Description_SepSep_TypeTravaux_SepAtt_execution'));
    description.objet = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_Description_SepAtt_objet'));
    return description;
  }

  private sanitizeString(value: any): string | null {
    if (typeof value !== 'string') {
      return value;
    }
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : null;
  }
}
